import { useNavigation } from "@react-navigation/native";
import React, { useEffect } from "react";
import { View, Text, Pressable, ScrollView, BackHandler } from "react-native";
import { Colors } from "../../../../globalStyles/ColorConfig";
import dimensions from "../../../../globalStyles/dimensions";
import BookingCard from "./BookingCard";

interface DataItem {
  experience: {
    id: string;
    name: string;
    title: string;
    bookingSlot: string;
    location: string;
    image: string;
    startTime: string;
    endTime: string;
  };
  booker: {
    id: string;
    name: string;
    phoneNumber: number;
    countryCode: string;
  };
  _id: string;
  bookingId: string;
  chatId: string;
  bookedFor: string;
  participants: string[];
  bookingStatus: string;
  paymentStatus: string;
  adminReviewed: boolean;
  experienceReview: any[]; // Update with actual type if possible
  createdAt: string;
  updatedAt: string;
  __v: number;
  adminCancellationReason: string;
}
interface TagStyle {
  backgroundColor: string;
  opacity?: number;
}
const BookingStatusCard = ({ data }: { data: DataItem[] }) => {
  const navigation = useNavigation();
  const getTagStyle = (bookingStatus: string): TagStyle => {
    switch (bookingStatus) {
      case "confirmed":
        return { backgroundColor: Colors.gold10 };
      case "pending":
        return { backgroundColor: Colors.black100, opacity: 0.6 };
      case "cancelled":
        return { backgroundColor: Colors.black100, opacity: 0.5 };
      default:
        return { backgroundColor: Colors.gold10 }; // Default tagStyle, modify as needed
    }
  };
  return (
    // <ScrollView>
    <View
      style={{
        paddingVertical: dimensions.paddingVertical,
        paddingHorizontal: dimensions.paddingHorizontal * 1,
        // borderWidth:1,
        // borderColor:"red"
      }}
    >
      {data?.map((item, index) => (
        <Pressable
          key={index}
          onPress={
            item.bookingStatus !== "cancelled"
              ? () => {
                  navigation?.navigate("booking-details", {
                    _id: item?.experience?.id,
                    status: item?.bookingStatus,
                    singleBookingData: item,
                  });
                }
              : undefined
          }
        >
          <BookingCard
            image={item?.experience?.image}
            imgHeight={150}
            statusTag={true}
            edit={false}
            data={item}
            grayImg={false}
            bgColor={Colors.grey90}
            tagStyle={getTagStyle(item.bookingStatus)}
          />
        </Pressable>
      ))}
    </View>
    // </ScrollView>
  );
};
export default BookingStatusCard;
